module.exports = __webpack_public_path__ + "static/media/by_fccn_negative.404a1471.svg";